// Hvordan et dokument skal presenteres i den offentlige lenken.
//
// Lenken tegnet alt som en faktura: overskriften sa «Faktura» ogsaa paa en
// kreditnota, den viste «Forfall» paa et dokument uten forfallsdato, og summen het
// «Totalt» paa et belop kunden har til gode i stedet for skal betale. PDF-en bak
// samme lenke har hatt skillet hele tiden (`flags.isCredit` i
// functions/mail/invoicePdf.ts) — det var bare HTML-visningen som manglet det.
//
// Reglene ligger her, ikke i selve visningen, slik at de kan testes som det de er:
// en oversettelse fra dokumenttype til ord og fortegn.
(function initInvoicePublicDocument(global) {
  const text = (value) => String(value || '').trim();
  const date = (value) => text(value).slice(0, 10);

  const KIND_LABELS = {
    offer: 'Tilbud',
    order_confirmation: 'Ordrebekreftelse',
    credit: 'Kreditnota',
    invoice: 'Faktura',
  };

  const presentation = (invoice) => {
    const doc = invoice || {};
    const kind = text(doc.kind);
    const isOffer = kind === 'offer';
    const isCredit = kind === 'credit';
    return {
      isOffer,
      isCredit,
      documentLabel: KIND_LABELS[kind] || KIND_LABELS.invoice,
      // En kreditnota har ingen forfallsdato. Den skal i stedet vise hvilket salg den
      // gjelder — bokfoeringsforskriften § 5-2-7 krever referansen, og det er den
      // kunden trenger for aa kjenne igjen hva som er kreditert.
      //
      // «Gjelder: 11» leste rart naar referansen er et bart fakturanummer. Krediterer
      // man en faktura, vet dokumentet at referansen ER et fakturanummer, og sier det.
      // En fri kreditnota har fritekst («avtale 2025-04», en periode, et gammelt
      // system) og maa beholde den noytrale ordlyden.
      secondaryLabel: isCredit
        ? (doc.creditReferenceIsInvoice ? 'Gjelder fakturanummer' : 'Gjelder')
        : isOffer ? 'Gyldig til' : 'Forfall',
      secondaryValue: isCredit ? text(doc.creditReference) : date(doc.validUntil || doc.dueDate),
      dateLabel: isCredit ? 'Kreditnotadato' : 'Dato',
      totalLabel: isCredit ? 'Beløp til gode' : 'Totalt',
    };
  };

  // Kreditnotaer finnes med to fortegnskonvensjoner: en laget av en faktura har
  // negative linjebelop, en fri kreditnota fra salgseditoren positive. Begge skal
  // lese «Beloep til gode 250 kr», ikke «-250 kr» — fortegnet hoerer i bokfoeringen,
  // ikke paa dokumentet kunden faar. Samme regel som PDF-malen.
  const displayAmount = (invoice, value) => {
    const amount = Number(value) || 0;
    return text(invoice?.kind) === 'credit' ? Math.abs(amount) : amount;
  };

  global.PlummeInvoicePublicDocument = { presentation, displayAmount };
})(typeof window !== 'undefined' ? window : globalThis);
